var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crud_module--Select_weekday"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.tran(_vm.k, _vm.col)))]),_c('SelectionFrom',{attrs:{"view":false,"value":_vm.value,"closeable":true,"filterable":true,"multiple":true,"option":_vm.selectKey,"setup":{label:'name',value:'name'}},on:{"input":_vm.selected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }